export const MAX_GUESS_LENGTH = 5
export const MAX_GUESSES = 5
